import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCirclePriceNightlyUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#999" cx={28} cy={28} r={28} />
        <path
          fill="#CCC"
          d="M31 24l-2.351 1.236.449-2.618-1.902-1.854 2.628-.382L31 18l1.176 2.382 2.628.382-1.902 1.854.45 2.618zm7.5 3.75l-1.47.773.281-1.637-1.189-1.159 1.643-.238L38.5 24l.735 1.489 1.643.238-1.19 1.16.281 1.636zM32 32.5l-1.763.927.336-1.963-1.426-1.391 1.971-.287L32 28l.882 1.786 1.971.287-1.426 1.39.336 1.964z"
        />
        <path
          d="M27 40c3.076 0 5.88-1.157 8.004-3.06-11.414.834-17.097-12.402-7.515-20.93A12.21 12.21 0 0027 16c-6.627 0-12 5.373-12 12s5.373 12 12 12z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

SvgPicCirclePriceNightlyUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCirclePriceNightlyUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCirclePriceNightlyUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
